import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "@mui/material";
import Logo from '../Images/savetheseaturtlelogo.webp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const Navigation = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const isSubmenuOpen = Boolean(submenuAnchorEl);
  const [openMenu, setOpenMenu] = useState(null);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleSubmenuClick = (event, menuLabel) => {
    setSubmenuAnchorEl(event.currentTarget);
    setOpenMenu(menuLabel); // Store the label of the menu being opened
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null);
    setOpenMenu(null); // Reset the open menu
  };

  const links = [
    { label: "Home", to: "/" },

    {
      label: "Programs",
      to: "",
      submenu: [
        { label: "Education/Awareness", to: "/Education" },
        { label: "Research", to: "/HawksbillProject" },
        { label: "Conservation", to: "/Conservation" },
        { label: "Scholarship program", to: "/ScholarshipProgram" },
      ],
    },
    // { label: "Foundation News", to: "/FoundationNews" },
    // { label: "Sea Turtle Facts", to: "/SeaTurtleFacts" },
    {
      label: "How You Can Help",
      to: "",
      submenu: [
        { label: "Become a Member", to: "/Membership/BecomeAMember" },
        { label: "Become a Corporate Partner", to: "https://savetheseaturtle.org/Support/CorporatePartner.html" },
        { label: "Adopt a Nest", to: "/AdoptSeaTurtle" },
        { label: "Florida Hawksbill Project", to: "/HawksbillProject" },
        { label: "Boat/Property Donations and Leases", to: "https://donatetheboattocharity.com/" },
      ],
    },
    // { label: "We Support", to: "/WeSupport" },
    { label: "Sponsors", to: "/Sponsors" },
    { label: "Contact", to: "/Contact" },
    { label: "Donate", to: "https://savetheseaturtle.org/Support/CashDonation.html" },
  ];

  const renderLinks = () =>
    links.map((link) =>
      link.submenu ? (
        <div key={link.label}>
          <Button
            onClick={(e) => handleSubmenuClick(e, link.label)}
            sx={{
              color: "#F27920",
              fontWeight: "bold",
              // minWidth: '150px',
              // padding: "10px 16px",
              fontSize: "0.875rem", // Standardized text size
            }}
          >
            {link.label}
            <ArrowDropDownIcon style={{ color: "#009293" }} />
          </Button>
          <Menu
            anchorEl={submenuAnchorEl}
            open={openMenu === link.label}
            onClose={handleSubmenuClose}
          >
            {link.submenu.map((sublink) => (
              <MenuItem
                key={sublink.label}
                onClick={handleSubmenuClose}
                sx={{ fontSize: "0.875rem" }} // Submenu text size
              >
                <Link
                  href={sublink.to}
                  sx={{
                    color: "#F27920",
                    fontSize: "0.875rem", // parent MenuItem
                    fontWeight: 'bold'
                  }}
                  underline="none"
                >
                  {sublink.label}
                </Link>
              </MenuItem>
            ))}
          </Menu>
        </div>
      ) : (
        <Button
          size="large"
          key={link.label}
          sx={{
            color: link.label === "Donate" ? "#FFFFFF" : "#F27920",
            backgroundColor: link.label === "Donate" ? "#F27920" : "transparent",
            fontWeight: "bold",
            fontSize: "0.875rem",
            height: "100%", // Take full height
            padding: "0", // Remove default padding
            ...(link.label === "Donate" && {
              height: "64px", // Standard AppBar height
              display: "flex",
              alignItems: "stretch", // Helps with vertical alignment
            }),
            "&:hover": {
              backgroundColor: link.label === "Donate" ? "#B71C1C" : "rgba(242, 121, 32, 0.1)",
            },
          }}
        >
          <Link
            href={link.to}
            sx={{
              color: link.label === "Donate" ? "#FFFFFF" : "#F27920",
              fontWeight: "bold",
              textDecoration: "none",
              fontSize: "inherit",
              display: "flex",
              alignItems: "center",
              height: "100%", // Make link take full height
              padding: "0 16px", // Add padding to the link instead of the button
            }}
          >
            {link.label}
          </Link>
        </Button>
      )
    );

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#ffffff", boxShadow: "none" }}
    >
      <Toolbar className="flex items-center relative justify-between">
        {/* Logo */}
        <div className="relative">
          <Link href="/">
            <img
              src={Logo}
              alt="National Save The Sea Turtle Foundation Logo"
              title="National Save The Sea Turtle Foundation"
              className="object-contain absolute bg-white p-5"
              style={{
                maxWidth: "130px",
                height: "auto",
                left: "12px",
                top: "-30px",
                zIndex: 1,
              }}
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-4">
          {renderLinks()}
        </div>

        {/* Mobile Navigation */}
        <IconButton
          edge="end"
          sx={{
            display: { md: "none" },
            color: "#F27920",
            fontSize: "0.875rem", // Slightly larger for mobile menu icon
          }}
          aria-label="menu"
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>

        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
          <List sx={{ fontSize: "0.875rem" }}> {/* Base font size for mobile menu */}
            {links.map((link) =>
              link.submenu ? (
                <div key={link.label}>
                  <ListItem disablePadding>
                    <ListItemButton onClick={handleSubmenuClick}>
                      <ListItemText
                        primary={link.label}
                        primaryTypographyProps={{ fontSize: "0.875rem", color: '#F27920' }} // Standardized text size
                      />
                      <ArrowDropDownIcon style={{ color: "#009293" }} />
                    </ListItemButton>

                  </ListItem>
                  {isSubmenuOpen &&
                    link.submenu.map((sublink) => (
                      <ListItem key={sublink.label} disablePadding>
                        <ListItemButton>
                          <Link href={sublink.to} underline="none" style={{ color: '#F27920' }}>
                            <ListItemText
                              primary={sublink.label}
                              primaryTypographyProps={{ fontSize: "0.875rem" }} // Standardized text size
                            />
                          </Link>
                        </ListItemButton>
                      </ListItem>
                    ))}
                </div>
              ) : (
                <ListItem key={link.label} disablePadding>
                  <ListItemButton>
                    <Link href={link.to} underline="none" style={{ color: '#F27920' }}>
                      <ListItemText
                        primary={link.label}
                        primaryTypographyProps={{ fontSize: "0.875rem" }} // Standardized text size
                      />
                    </Link>
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
